import { apiRequest } from 'lib/apiRequest'
const { get } = apiRequest

// todo - redirect to /login if no token is provided for an endpoint that requires
// authentication
export const taskRuns = {
  index: (token) => get(token, '/admin/task_runs'),
  show: (id, token) => get(token, `/admin/task_runs/${id}`),
}
